module.exports = __webpack_public_path__ + "03_glasses_red.9a8a9c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/03_glasses_red.png
// module id = aH1b
// module chunks = 0